import { postprocessAssignmentName } from '../utils/postprocessAssignmentName';
var MAX_NAME_LENGTH = 255;
var assignmentNameValidations = [
    {
        validate: function (val) { return !!postprocessAssignmentName(val || ''); },
        errorText: 'Name the assignment',
    },
];
export { MAX_NAME_LENGTH, assignmentNameValidations };
